import { render, staticRenderFns } from "./NewNote.vue?vue&type=template&id=8772c898&scoped=true&"
import script from "./NewNote.vue?vue&type=script&lang=ts&"
export * from "./NewNote.vue?vue&type=script&lang=ts&"
import style0 from "./NewNote.vue?vue&type=style&index=0&id=8772c898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8772c898",
  null
  
)

export default component.exports